import api from "@/services/api";
import api2 from "@/services/api2";
import axios from "axios";
export default {
  get(url) {
    return api().get(url);
  },
  post(url, data) {
    return api().post(url, data);
  },
  put(url, data) {
    return api().put(url, data);
  },
  delete(url) {
    return api().delete(url);
  },
  get2(url) {
    return api2().get(url);
  },
  post2(url, data) {
    return api2().post(url, data);
  },
  put2(url, data) {
    return api2().put(url, data);
  },
  delete2(url) {
    return api2().delete(url);
  }
};
